import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '@env';

export function adminGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        if (environment.isAdmin === false) {
            return router.createUrlTree(['/auth/sign-in']);
        }
        return true;
    };
}
